
module.factory('Issues', function($http) {

    function Issues(model, id) {

        var self = this;

        this.modelName = model;
        this.modelId = id;
        this.url = "/api/" + model + "/" + id + "/issues";

        this.$update = function(data) {
            angular.extend(this, data);
        };

        this.$refresh = function() {
            return $http.get(self.url).then(function(response) {
                self.$update(response.data);
                return self;
            });
        };
    }

    Issues.load = function(model, id) {
        var issues = new Issues(model, id);
        return issues.$refresh();
    };

    return Issues;
});


module.service('IssueService', function($http, $q, ApiUrl, ModelService) {
    var data = {};

    this.getIssues = function(modelName, id, create) {
        return data[modelName] && data[modelName][id]
    }

    this.loadIssues = function(modelName, id) {
        if (data[modelName] && data[modelName][id]) {
            return $q.when(data[modelName][id])
        }
        data[modelName] = data[modelName] || {};
        data[modelName][id] = data[modelName][id] || {};
        return this.refreshIssues(modelName, id);
    }

    this.refreshIssues = function(modelName, id) {
        return ModelService.debouncedRelation(modelName, id, 'issues/aggregate')
            .then(function(issues) {
                data[modelName] = data[modelName] || {};
                data[modelName][id] = data[modelName][id] || {};
                angular.copy(issues.issues, data[modelName][id]);
                return data[modelName][id];
            });
    }

    this.refreshIfLoaded = function(modelName, id) {
        if (data[modelName] && data[modelName][id]) {
            this.refreshIssues(modelName, id);
        }
    }

    this.clearIssues = function(modelName, id) {
        if (data[modelName] && data[modelName][id]) {
            delete data[modelName][id];
        }
    }

    ModelService.listenForIssues('all', this.refreshIfLoaded.bind(this));

});